import { ProgressSpinner } from 'modules/ai/ui/animations/ProgressSpinner';
import { CompleteQuery } from 'modules/queryBuilder/types';
import { BUTTON_VARIANTS, IconButton } from 'ui/button';
import { AiSparkle16 } from 'ui/icons';
import { PopoverTrigger } from 'ui/popover';
import { AIQuerySummary } from 'ui/queryBuilder';
import { Tooltip } from 'ui/tooltip';
import { useListId, useTranslation } from '../../../hooks';
import { useSuggestedDescription } from '../../../hooks/useSuggestedDescription';

type Props = {
  isLoading?: boolean;
  onCommit: (desc: string) => void;
  query: CompleteQuery;
};

export const testIds = {
  loader: 'aiqs-input-btn-loading',
  trigger: 'aiqs-input-btn-trigger',
};

export const AIQuerySummaryInputButton = ({
  isLoading: isLoadingContainer = false,
  onCommit,
  query,
}: Props) => {
  const { t } = useTranslation();
  const listId = useListId();
  const { descriptionInput, ...props } = useSuggestedDescription({ listId, query });

  return isLoadingContainer ? (
    <Tooltip tooltipContent={t('modal.newDynamicList.field.description.aiLoading')}>
      <ProgressSpinner width={36} data-ai-control="true" data-test={testIds.loader} />
    </Tooltip>
  ) : (
    <AIQuerySummary onCommit={() => onCommit(descriptionInput)} {...props}>
      <PopoverTrigger data-ai-control="true" data-test={testIds.trigger} asChild>
        <IconButton
          aria-label={t('storybook.ai.summary.generateSummary')}
          type="button"
          variant={BUTTON_VARIANTS.GHOST}
        >
          <AiSparkle16 />
        </IconButton>
      </PopoverTrigger>
    </AIQuerySummary>
  );
};
